export default class Response {
    make(status, type, payload) {
        return {
            status,
            type,
            payload
        }
    }
}
